<template>
  <div class="match-invite-page page">
    <Breadcrumb></Breadcrumb>
    <!-- 主体 -->
    <div class="tabList-content">
      <div class="tablist-lt">
        <TabVertical
          :tabData="tabList"
          :code="categoryId"
          :seccode="seccode"
          :subcode="subcode"
          @changeSecTab="changeSecTab"
        ></TabVertical>
      </div>
      <div class="tablist-rt">
        <div class="rt-title">
          <div class="rt-title-name">
            <div class="title-row">
              <div class="hr"></div>
              <div class="name">{{ currentCategory?.categoryName }}</div>
              <div class="english-name">{{ currentCategory?.englishName }}</div>
            </div>
          </div>
          <div class="rt-btn">
            <img src="@/assets/images/icon-8.png" alt="" class="icon-image" />
            <div class="text">服务介绍</div>
          </div>
        </div>
        <div class="rt-message" v-html="article.articleContent"></div>
        <!-- 资讯 -->
        <div class="news-content">
          <div class="title-row">
            <div class="hr"></div>
            <div class="name">往期回顾</div>
            <div class="english-name">Review of Previous Issues</div>
          </div>
          <div class="news-list">
            <div
              class="list-row"
              v-for="(item, index) in newsList"
              :key="index"
              @click="toArticleDetail(item)"
            >
              <div class="round"></div>
              <div class="name">{{ item.articleName }}</div>
              <div class="date">[{{ item.releaseTime }}]</div>
            </div>
          </div>
          <el-empty
            description="暂无内容~"
            v-if="newsList.length == 0"
          ></el-empty>
          <!-- 分页 -->
          <Pagination
            :pageSize="pageSize"
            :pageCount="pageCount"
            @changePageClick="changePageClick"
            v-if="newsList.length > 0"
          ></Pagination>
          <!-- <div class="m-bot" v-if="newsList.length > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="pageCount"
              @current-change="changePageClick"
            >
            </el-pagination>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import TabVertical from '@/components/list/tab-vertical.vue'
import Pagination from '@/components/common/Pagination.vue'
import { getArticleById, getArticlePage } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
export default {
  name: 'Policy',
  components: { Breadcrumb, TabVertical, Pagination },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: '',
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    }
  },
  methods: {
    //统一获取数据
    async fetchData() {
      if (!this.tabcode) return
      const res = await getNavItemByCode(this.tabcode)
      if (!res.data) return
      this.tabList = res.data[0]

      // 🔧 写死技能提升的 linkType 为 5
      if (this.tabList && this.tabList.list) {
        const skillItem = this.tabList.list.find(item => item.categoryName === '技能提升')
        if (skillItem) {
          skillItem.linkType = '5'
        }

        // 设置当前分类（保持左侧菜单选中状态）
        if (this.categoryId) {
          const currentItem = this.tabList.list.find(item => item.categoryCode == this.categoryId)
          if (currentItem) {
            this.currentCategory = currentItem
          }
        }
      }
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
      })
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }
      this.getServiceArticlePage(item.categoryCode)

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/singleImage' + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType)
      }
      if (item.linkType == 4) {
        console.log(item.linkType)
      }
      if (item.linkType == 5) {
        url = '/tabList' + url + '&id=' + item.linkUrl
      }
      this.$router.push({
        path: url
      })
      if (item.linkUrl != 'null' && item.linkUrl)
        return this.getArticleData(item.linkUrl)
    },
    //获取文章列表
    getServiceArticlePage(categoryCode, page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: categoryCode
      }).then((res) => {
        console.log(res.data)
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getServiceArticlePage(this.categoryId, page)
    },
    // 跳转
    toArticleDetail(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      } else {
        let url =
          '/articleDetail?categoryId=' +
          this.currentCategory.categoryCode +
          '&linkType=3&tabcode=' +
          this.tabcode +
          '&seccode=' +
          this.seccode +
          '&id=' +
          item.articleId
        this.$router.push(url)
      }
    }
  },
  async created() {
    this.pageType = this.$route.query?.linkType
    let id = this.$route.query?.id
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.seccode = this.$route.query?.seccode
    
    // 先获取导航数据，确保左侧菜单选中状态正确
    await this.fetchData()
    
    // 获取往期回顾列表
    this.getServiceArticlePage(this.categoryId)

    // 获取服务介绍内容
    if (id != 'null' && id) {
      this.getArticleData(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .tabList-content {
    width: 1340px;
    margin: 34px auto 120px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    .tablist-rt {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-left: 64px;
      .news-content {
        display: flex;
        flex-direction: column;
        margin-top: 48px;
        .news-list {
          display: flex;
          flex-direction: column;
          .list-row {
            height: 30px;
            line-height: 30px;
            display: flex;
            flex-direction: row;
            margin-bottom: 24px;
            cursor: pointer;
            .date {
              color: #999;
              font-size: 16px;
              font-weight: 400;
            }
            .name {
              flex: 1;
              margin: 0 30px 0 14px;
              color: #333;
              font-size: 18px;
              font-weight: 400;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .round {
              width: 5px;
              height: 5px;
              background: #999;
              margin: auto 0;
              border-radius: 50%;
            }
          }
          .list-row:last-child {
            margin-bottom: 0;
          }
          .list-row:hover {
            .date {
              color: #1b56a9;
            }
            .name {
              color: #1b56a9;
              text-decoration: underline;
            }
            .round {
              background: #1b56a9;
            }
          }
        }
        .title-row {
          display: flex;
          flex-direction: row;
          height: 36px;
          line-height: 36px;
          margin-bottom: 14px;
          .english-name {
            margin-left: 6px;
            color: #999;
            font-size: 20px;
          }
          .name {
            color: #000;
            font-size: 26px;
            font-weight: 600;
            margin-left: 6px;
          }
          .hr {
            width: 3px;
            height: 21px;
            background: #1b56a9;
            margin: auto 0;
          }
        }
      }
      .rt-message {
        color: #333;
        font-size: 22px;
        line-height: 33px;
        font-weight: 400;
        margin-top: 14px;
        margin-bottom: 24px;
      }
      .rt-title {
        height: 54px;
        display: flex;
        flex-direction: row;
        .rt-btn {
          border-radius: 0 30px 0 30px;
          background: #1b56a9;
          width: 149px;
          height: 54px;
          line-height: 54px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          .icon-image {
            width: 18px;
            height: 20px;
            margin: auto 0;
          }
          .text {
            color: #fff;
            font-size: 24px;
            margin-left: 8px;
          }
        }
        .rt-title-name {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          flex: 1;
          .title-row {
            display: flex;
            flex-direction: row;
            height: 36px;
            line-height: 36px;
            .english-name {
              margin-left: 6px;
              color: #999;
              font-size: 20px;
            }
            .name {
              color: #000;
              font-size: 26px;
              font-weight: 600;
              margin-left: 6px;
            }
            .hr {
              width: 3px;
              height: 21px;
              background: #1b56a9;
              margin: auto 0;
            }
          }
        }
      }
    }
    .tablist-lt {
      display: flex;
      flex-direction: column;
      width: 173px;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .tabList-content {
      width: 375px;
      margin: 0 0 60px;
      flex-direction: column;
      .tablist-rt {
        margin: 20px auto 0;
        width: 345px;
        .news-content {
          margin-top: 24px;
          .news-list {
            .list-row {
              height: 25px;
              line-height: 25px;
              margin-bottom: 12px;
              .date {
                margin-left: 8px;
                font-size: 13px;
              }
              .name {
                font-size: 13px;
                margin: 0 10px 0 7px;
              }
              .round {
                width: 3px;
                height: 3px;
              }
            }
          }
          .title-row {
            height: 25px;
            line-height: 25px;
            margin-bottom: 10px;
            .english-name {
              margin-left: 4px;
              font-size: 14px;
            }
            .name {
              font-size: 16px;
              margin-bottom: 4px;
            }
            .hr {
              width: 2px;
              height: 15px;
            }
          }
        }
        .rt-message {
          font-size: 16px;
          line-height: 25px;
          margin-top: 10px;
          margin-bottom: 15px;
        }
        .rt-title {
          height: 40px;
          .rt-btn {
            height: 40px;
            line-height: 40px;
            width: 80px;
            border-radius: 0 20px 0 20px;
            .icon-image {
              width: 12px;
              height: 13px;
            }
            .text {
              font-size: 12px;
            }
          }
          .rt-title-name {
            .title-row {
              height: 25px;
              line-height: 25px;
              .english-name {
                font-size: 12px;
                margin-left: 4px;
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              .name {
                font-size: 16px;
                margin-left: 4px;
              }
              .hr {
                width: 2px;
                height: 11px;
              }
            }
          }
        }
      }
      .tablist-lt {
        width: 375px;
      }
    }
  }
}
</style>
